import i18n from 'i18next';

/**
 * CON-1613 — the ACTIVE locale for Intl date/time formatting.
 *
 * The app called `toLocaleDateString('en-GB', …)` in 119 places across 56 files.
 * That hard-codes English weekday and month names into every rendered date, so
 * the feed showed "Heute" and "Morgen" translated (they are i18n keys) and then
 * "Thu 14 Aug" in English right beside them — which reads as the translation
 * being half-finished, because visually it is.
 *
 * No translation keys are needed for this: Intl already knows every weekday and
 * month name in all 12 of our locales. The bug was only ever passing the wrong
 * locale tag. Pass this instead of a literal:
 *
 *   d.toLocaleDateString(dtLocale(), { weekday: 'short', day: 'numeric' })
 *
 * `resolvedLanguage` is used first so a region-tagged language (e.g. 'de-AT')
 * resolves to the bundle we actually loaded, and the split drops any region
 * suffix i18next did not resolve. Falls back to 'en-GB' — the previous
 * behaviour — if i18next is somehow not initialised, so a formatting call can
 * never throw.
 */
export function dtLocale() {
  try {
    return i18n.resolvedLanguage || i18n.language || 'en-GB';
  } catch {
    return 'en-GB';
  }
}

export default dtLocale;
